import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["file", "applyBtn", "fileLabel"]
  static values = { url: String }

  fileChange() {
    const file = this.fileTarget.files?.[0]
    if (!file) return
    if (this.hasFileLabelTarget) {
      this.fileLabelTarget.textContent = file.name
      this.fileLabelTarget.hidden = false
    }
  }

  apply(event) {
    event.preventDefault()
    this.submit({})
  }

  refresh(event) {
    event.preventDefault()
    this.submit({ refresh: "1" })
  }

  removeAudio(event) {
    event.preventDefault()
    this.submit({ remove_soundtrack: "1" })
  }

  async submit(extraFields) {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    const body = new FormData()
    Object.entries(extraFields).forEach(([key, value]) => body.append(key, value))
    if (this.hasFileTarget && this.fileTarget.files?.[0]) {
      body.append("soundtrack", this.fileTarget.files[0])
    }

    const buttons = this.element.querySelectorAll("button")
    buttons.forEach(b => { b.disabled = true })
    if (this.hasApplyBtnTarget) this.applyBtnTarget.textContent = "Applying…"

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        body,
        headers: { "X-CSRF-Token": csrf, Accept: "text/html" },
        credentials: "same-origin",
      })

      if (response.ok) {
        if (typeof Turbo !== "undefined") {
          Turbo.visit(response.url)
        } else {
          window.location.href = response.url
        }
      } else {
        buttons.forEach(b => { b.disabled = false })
        if (this.hasApplyBtnTarget) this.applyBtnTarget.textContent = "Apply music"
      }
    } catch {
      buttons.forEach(b => { b.disabled = false })
      if (this.hasApplyBtnTarget) this.applyBtnTarget.textContent = "Apply music"
    }
  }
}
